import { useEffect, useState } from "react";
import InternetCheckModal from "@/components/internet-check-modal/InternetCheckModal";

export function InternetConnectionChecker() {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const handleRetry = () => {
    setIsOnline(navigator.onLine);
  };

  return <InternetCheckModal isOpen={!isOnline} onRetry={handleRetry} />;
}